import { RemoteDeleteInternshipLocation } from 'data/usecases';
import { makeApiUrlInternshipLocations } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteDeleteInternshipLocation =
  (): RemoteDeleteInternshipLocation => {
    return new RemoteDeleteInternshipLocation(
      makeApiUrlInternshipLocations(),
      makeAxiosHttpClient(),
    );
  };
